import { Company } from "generated/graphql";

export const getPrimaryContact = (company: Company) => {
  return company.contacts.find((contact) => contact.primary) || null;
};
